namespace Matrix.Data {
    export interface CurrencyForm {
        CurrencyCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class CurrencyForm extends Serenity.PrefixedContext {
        static formKey = 'Data.Currency';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!CurrencyForm.init)  {
                CurrencyForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(CurrencyForm, [
                    'CurrencyCode', w0,
                    'Name', w0,
                    'DefaultSortOrder', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
